import React from 'react';
import useAppContent from '../../../hooks/useAppContent';
import { useApp } from '../../../context/AppContext';
import useAnalytics from '../../../hooks/useAnalytics';
import './Slide1.scss';

const Slide1 = ({ onNext, canProceed = true }) => {
  const { appContent, loading, error } = useAppContent();
  const { actions } = useApp();
  const { trackBoardingPassStart } = useAnalytics();


  const handleStart = () => {
    if (canProceed && onNext) {
      trackBoardingPassStart();
      onNext();

    }
  };

  const handleBackToHome = () => {
    actions.setView('home');
  };

  if (loading) {
    return (
      <div className="slide slide1">
        <div className="slide1__loading">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="slide slide1">
      <div className="slide1__container">
        <div className="slide1__content">
          <h1 className="slide1__title">
            {appContent?.acf?.slide_1_intro_title}
          </h1>

          <p className="question-slide__description">
            {appContent?.acf?.slide_1_description}
          </p>

          {error && (
            <p className="slide1__fallback-notice">
              Using default content (WordPress connection issue)
            </p>
          )}

          <div className="slide1__features">
            {appContent?.acf?.slide_1_features?.map((feature, index) => (
              <div key={feature.feature_text || index} className="feature-item">
                <span className="feature-icon">{feature.feature_icon}</span>
                <span className="feature-text">{feature.feature_text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="slide1__actions game-navigation">
          <button className="btn-primary" onClick={handleBackToHome}>
            Back
          </button>

          <button
            className="slide1__start-button btn-primary inverted"
            onClick={handleStart}
            disabled={!canProceed}
          >
            {appContent?.acf?.slide_1_button_text || 'Start Your Journey'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Slide1;
